import { render, staticRenderFns } from "./UsuarioAdmin.vue?vue&type=template&id=a4aa035e&"
import script from "./UsuarioAdmin.vue?vue&type=script&lang=js&"
export * from "./UsuarioAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports